var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 2.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM1.75 4a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM1.75 9a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1-.75-.75V9Zm1.5.75v11h2.5v-11h-2.5ZM11.288 10.309c1.029-1.136 2.598-2.06 4.712-2.06s3.683.924 4.712 2.06c1.001 1.105 1.538 2.465 1.538 3.44v7.75a.75.75 0 0 1-.75.75H18a.75.75 0 0 1-.75-.75v-7c0-.329-.13-.728-.371-1.036-.232-.295-.53-.463-.879-.463-.408 0-.697.155-.896.39-.21.249-.354.63-.354 1.11v7a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-7.75c0-.976.537-2.336 1.538-3.441Zm1.111 1.007c-.81.895-1.149 1.91-1.149 2.434v7h2V14.5c0-.77.231-1.514.709-2.078.488-.577 1.199-.922 2.041-.922.9 0 1.603.457 2.058 1.037a3.26 3.26 0 0 1 .692 1.963v6.25h2v-7c0-.524-.338-1.539-1.15-2.434-.783-.865-1.964-1.566-3.6-1.566-1.636 0-2.817.701-3.6 1.566Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.ce7fbe8196e59afc8e367ad9f49e2c5a.svg";
export { ForwardRef as ReactComponent };